/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsControllerGetTokenForProviderQueryResponse, IntegrationsControllerGetTokenForProviderPathParams, IntegrationsControllerGetTokenForProvider404 } from "../../models/integrationsController/IntegrationsControllerGetTokenForProvider";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { integrationsControllerGetTokenForProvider } from "../../clients/integrationsService/integrationsControllerGetTokenForProvider";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const integrationsControllerGetTokenForProviderQueryKey = (provider: IntegrationsControllerGetTokenForProviderPathParams["provider"]) => [{
  url: '/api/v1/integrations/:provider',
  params: {
    provider: provider
  }
}] as const;
export type IntegrationsControllerGetTokenForProviderQueryKey = ReturnType<typeof integrationsControllerGetTokenForProviderQueryKey>;
export function integrationsControllerGetTokenForProviderQueryOptions(provider: IntegrationsControllerGetTokenForProviderPathParams["provider"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = integrationsControllerGetTokenForProviderQueryKey(provider);
  return queryOptions<IntegrationsControllerGetTokenForProviderQueryResponse, ResponseErrorConfig<IntegrationsControllerGetTokenForProvider404>, IntegrationsControllerGetTokenForProviderQueryResponse, typeof queryKey>({
    enabled: !!provider,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return integrationsControllerGetTokenForProvider(provider, config);
    }
  });
}

/**
 * @summary Get the current access token for a provider
 * {@link /api/v1/integrations/:provider}
 * @deprecated
 */
export function useIntegrationsControllerGetTokenForProvider<TData = IntegrationsControllerGetTokenForProviderQueryResponse, TQueryData = IntegrationsControllerGetTokenForProviderQueryResponse, TQueryKey extends QueryKey = IntegrationsControllerGetTokenForProviderQueryKey>(provider: IntegrationsControllerGetTokenForProviderPathParams["provider"], options: {
  query?: Partial<QueryObserverOptions<IntegrationsControllerGetTokenForProviderQueryResponse, ResponseErrorConfig<IntegrationsControllerGetTokenForProvider404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? integrationsControllerGetTokenForProviderQueryKey(provider);
  const query = useQuery({
    ...integrationsControllerGetTokenForProviderQueryOptions(provider, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IntegrationsControllerGetTokenForProvider404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}